<style scoped lang="scss" type="text/scss">
    .sponsorship-container-wrap{
        margin-bottom: -1rem;

        .submit-buttons {
            margin-top: 1rem;
        }

        .sponsorship-items {
            margin: 1rem 0;

            .sponsorship-items-wrap {
                margin: -1rem 0 0 -1rem;
                display: flex;
                flex-wrap: wrap;
            }

            .sponsorship-item {
                height: 8rem;
                width: calc(50% - 1rem);
                margin: 1rem 0 0 1rem;
            }
        }
    }

    @media screen and (min-width: 95rem) {
        .sponsorship-item {
            width: calc(33.3% - 1rem) !important;
        }
    }
</style>

<template>
    <div class="sponsorship-container-wrap">
        <block-divider>总经费</block-divider>

        <el-input clearable class="full-width" placeholder="单位：万元" v-model="funding">
            <template slot="append">万元</template>
        </el-input>

        <div class="submit-buttons">
            <el-button type="primary" plain @click="updateFunding()" :loading="requesting">保存</el-button>
            <el-button @click="reset()">重置</el-button>
        </div>

        <block-divider>赞助信息</block-divider>

        <div class="sponsorship-items">

            <div class="sponsorship-items-wrap">
                <add-block class="sponsorship-item" title="赞助" reversed @click.native="showEditor"></add-block>

                <sponsorship-item class="sponsorship-item" v-for="(sponsorship, index) in sponsorships" :key="index"
                                  :editable="true" :info="sponsorship" :index="index + 1"
                                  @call-edit="showUpdateEditor(sponsorship.id, ...arguments)"
                                  @call-remove="remove(sponsorship.id, ...arguments)"
                >
                </sponsorship-item>
            </div>
        </div>

        <popup :visible.sync="isEditorVisible"
               :is-update="isUpdateMode"
               :id="updateId"
               :deletable="isUpdateMode"
               @need-reload="loadPlayerSponsorships"
        >
        </popup>
    </div>
</template>

<script>
    import BlockDivider from '../../../../../components/divider/block';
    import Placeholder from '../../../../../components/placeholder/index';
    import SponsorshipItem from '../../../../sub-components/sponsorship-item/index';
    import AddBlock from '../../../../../components/add-block/index';
    import Popup from './popup';
    import {mapState} from 'vuex';

    export default {
        name: '',
        components: {
            BlockDivider,
            Placeholder,
            SponsorshipItem,
            AddBlock,
            Popup
        },
        data () {
            return {
                funding: null,
                isEditorVisible: false,
                deletable: false,
                isUpdateMode: false,
                updateId: null,
                requesting: false
            };
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId,
                currentManagedPlayerInfo: state => state.currentManagedPlayerInfo,
                sponsorships: state => state.currentManagedPlayerSponsorships
            })
        },
        watch: {
            currentManagedPlayerInfo: {
                immediate: true,
                handler (info) {
                    this.funding = info.funding;
                }
            },
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                    this.loadPlayerSponsorships();
                }
            }
        },
        methods: {
            updateFunding () {
                let funding = this.funding;
                if (funding === null || funding === '') {
                    this.$tip('参赛总经费不能为空');
                    return;
                }
                funding = +funding;
                if (isNaN(funding)) {
                    this.$tip('总经费必须是数字');
                    return;
                }
                if (funding < 0) {
                    this.$tip('总经费不能小于 0');
                    return;
                }
                if (funding > 10000) {
                    this.$tip('参赛总经费不能超过 1 亿元');
                    return;
                }
                this.$normalRequest('player/updateFunding', {
                    id: this.currentManagedPlayerId,
                    funding: funding
                }, '参赛总经费更新成功', true, this, 'requesting').then(_ => {
                    this.$store.dispatch('player/loadRegistrableManagedPlayerInfo').then();
                }).catch(_ => {
                });
            },
            reset () {
                this.funding = this.currentManagedPlayerInfo.funding;
            },
            loadPlayerSponsorships () {
                return this.$store.dispatch('player/loadSponsorships', {
                    id: this.currentManagedPlayerId
                }).then(response => {
                }).catch(_ => {
                });
            },
            showEditor () {
                this.updateId = null;
                this.isUpdateMode = false;
                this.isEditorVisible = true;
            },
            showUpdateEditor (id, callback) {
                this.updateId = id;
                this.isUpdateMode = true;
                this.isEditorVisible = true;
                callback();
            },
            remove (id, callback) {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('player/deleteSponsorship', {id}, '删除成功').then(_ => {
                        this.loadPlayerSponsorships().then(_ => {
                            callback();
                        });
                    }).catch(_ => {
                        callback();
                    });
                }).catch(_ => {
                    callback();
                });
            }
        }
    };
</script>
